import { FC } from 'react'
import styles from './BetPanel.module.css'

export interface BetPanelProps {
  children: React.ReactNode
}

export const BetPanel: FC<BetPanelProps> = ({ children }) => {
  return (
    <div
      className={`flex flex-col gap-5 bg-[var(--panel-bg)] border border-[var(--panel-border)] rounded-xl ${styles.betPanel}`}
    >
      {children}
    </div>
  )
}
